import {CREATE_GROUP_NEWS_START} from "../../types";

export const create_group_news = (payload) => ({
  type: CREATE_GROUP_NEWS_START,
  payload,
});
